import { isInteger } from "lodash"
import moment from "moment"

// return timestamp in date formated
export function getTimestamp(timestamp) {
  return moment(timestamp).format("YYYY, MMM, DD")
}

// return timestamp in formated based organization need
export function getTimestampFormated(timestamp) {
  return moment(timestamp).format("YYYY, MMM, DD, h:mm:ss a")
}

// get different date between inserted and now
export function getDiffDateFromNow(date) {
  return moment(date).fromNow()
}

// check is paramter one and parameter two is same
export function numberIsSame(first, second) {
  if (first === second) {
    return true
  } else {
    return false
  }
}

// check number is minus or not
export function checkForMinusNumber(e) {
  if (Math.sign(e.target.value) === -1) {
    return true
  }
  return false
}

// remove doument from state
export const removeDocument = setselectedFiles => {
  setselectedFiles({})
}

// get years from 2020 upto now
export const getYears = () => {
  const year = new Date().getFullYear()
  const arr = []
  for (let i = 2020; i <= year; i++) {
    arr.push({ value: i, label: i })
  }
  return arr
}

// get month name
export const getMonthName = month => {
  return moment()
    .month(month - 1)
    .format("MMMM")
}

// set toFixed in number
export const setToFixed = number => {
  if (!isInteger(number)) {
    return typeof number
  } else {
    return number
  }
}

// get expireation date base 6 month
export const getExpirationDateBaseMonth = () => {
  // Include Moment.js if using npm
  // const moment = require('moment');

  // Current date and time
  let now = moment()

  // Add 6 months and format to 'YYYY-MM-DD'
  return now.add(6, "months").format("YYYY-MM-DD")
}

// get expiratoin base year
export const getExpirationDateBaseYear = () => {
  // Include Moment.js if using npm
  // const moment = require('moment');

  // Current date and time
  let now = moment()

  // Add 6 months and format to 'YYYY-MM-DD'
  let monthBased = now.add(6, "months").format("YYYY-MM-DD")

  // Parse the date again and add another 6 months, then format
  return moment(monthBased).add(6, "months").format("YYYY-MM-DD")
}

export const getFormatedDate = date => {
  return moment(date).format("YYYY-MM-DD")
}

/**
 * Format number with comma separators for better readability
 * @param {number|string} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 0)
 * @returns {string} Formatted number with commas
 *
 * @example
 * formatNumberWithCommas(1234567) // "1,234,567"
 * formatNumberWithCommas(1234.56, 2) // "1,234.56"
 * formatNumberWithCommas(null) // "0"
 */
export const formatNumberWithCommas = (value, decimals = null) => {
  if (value === null || value === undefined || value === "") return "0"

  // Convert to string first (preserves decimals exactly)
  const stringValue = value.toString()

  // Split integer & decimal parts
  const [integerPart, decimalPart] = stringValue.split(".")

  // Format integer part with commas
  const formattedInt = Number(integerPart).toLocaleString("en-US")

  // If decimals is forced
  if (decimals !== null) {
    const fixedDecimal = Number("0." + (decimalPart || 0))
      .toFixed(decimals)
      .split(".")[1]
    return `${formattedInt}.${fixedDecimal}`
  }

  // If original number has decimals → preserve them without rounding
  return decimalPart ? `${formattedInt}.${decimalPart}` : formattedInt
}

/**
 * Calculate adjusted quantity including adjustments for transactions
 * Only applies adjustments to Receipt transactions, not Distributions
 *
 * @param {Object} transaction - The transaction object
 * @param {string} transaction.type - Transaction type ("Receipts" or other)
 * @param {number} transaction.qty_per_ip - Original quantity per IP UOM
 * @param {number} transaction.total_increase - Total increase from adjustments
 * @param {number} transaction.total_decrease - Total decrease from adjustments
 * @returns {number} Adjusted quantity
 *
 * @example
 * calculateAdjustedQuantity({
 *   type: "Receipts",
 *   qty_per_ip: 1000,
 *   total_increase: 500,
 *   total_decrease: 100
 * }) // Returns 1400
 *
 * calculateAdjustedQuantity({
 *   type: "Distributions",
 *   qty_per_ip: 1000,
 *   total_increase: 500,
 *   total_decrease: 100
 * }) // Returns 1000 (no adjustments for distributions)
 */
export const calculateAdjustedQuantity = transaction => {
  // Return 0 if transaction is null or undefined
  if (!transaction) {
    return 0
  }

  // Get original quantity, default to 0 if not available
  const originalQty = transaction?.qty_per_ip || 0

  // Only calculate adjustments for Receipts, not Distributions
  if (transaction?.type !== "Receipts") {
    return originalQty
  }

  // Get adjustment totals, default to 0 if not available
  const totalIncrease = transaction?.total_increase || 0
  const totalDecrease = transaction?.total_decrease || 0

  // Calculate adjusted quantity: original + increases - decreases
  return originalQty + totalIncrease - totalDecrease
}
